'use client';

import useSupport from '@/hooks/useSupport';
import { faCircleExclamation, faClose, faEnvelope, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { memo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Confetti from 'react-confetti';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SupportAnimation from '../../../public/assets/images/Animation-1715778919011.gif';
import SupportIcon from '../../../public/assets/images/comment.png';
import Success from '../../../public/assets/images/success-form.gif';
import * as commonAction from '../../redux/actions/common';
import { isEmpty } from '../../services/helperFunctions';
import './Support.css';
export interface SupportProps {
  supportForm?: any;
  showSupportForm: boolean;
  setShowSupportForm: (val: boolean) => void;
}
export const dynamic = 'force-static';
const Support = ({ supportForm, showSupportForm, setShowSupportForm }: SupportProps): JSX.Element => {
  const {
    handleClickOpen,
    open,
    handleFileChange,
    handleReset,
    fileName,
    handleDrop,
    handleDragLeave,
    handleDragEnter,
    handleDragOver,
    dragOver,
    selectedFile,
    outSideRef,
    errors,
    formData,
    handleInputChange,
    supportFormSchema,
    setErrors,
    message,
    setMessage,
    setFormData,
    handleOutsideClick,
  } = useSupport({ setShowSupportForm });

  // const userId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      await supportFormSchema.validate(
        {
          firstName: formData?.firstName,
          email: formData?.email, // Replace convertToHtml with the actual function to convert editorState to HTML
          issue: formData?.issue,
          additionalDetails: formData?.additionalDetails,
        },
        { abortEarly: false }
      );
      // handleValidateFormData()
      setErrors({});
      const data = new FormData();
      // data.append("user_id", UserId)
      data.append('first_name', formData.firstName);
      data.append('last_name', formData.lastName);
      data.append('email', formData.email);
      data.append('issue_type', formData.issue);
      data.append('additional_details', formData.additionalDetails);
      data.append('profile_picture', selectedFile === undefined || selectedFile === null ? '' : selectedFile);
      supportForm(data).then((res: any) => {
        if (res?.code === 200) {
          setMessage(res);
          setFormData({
            firstName: '',
            lastName: '',
            email: '',
            issue: '',
            additionalDetails: '',
          });
          handleReset();
        }
      });
    } catch (error: any) {
      const newErrors: Record<string, string> = {};
      error.inner.forEach((e: any) => {
        newErrors[e.path] = e.message;
      });
      setErrors(newErrors);
    }
  };

  return (
    <div ref={outSideRef}>
      {(open || showSupportForm) && (
        <div className="support-form-box shadow border-gradient border-gradient-purple overflow-hidden small-scroll-bar">
          <div className="support-form-header d-flex justify-content-between">
            <div className="px-2 py-2 header-text">
              <h6>Welcome to SQX Bonds Support </h6>
              <div className="row px-2">
                <p className="col-9 p-0 m-0 mt-1">
                  How can we assist you today? <br /> Please fill out the form below with your query or issue, and our support team will get
                  back to you as soon as possible.
                </p>
                <Image loading="lazy" width={70} height={70} alt="support-gif" src={SupportAnimation} className="col-3 p-0 m-0" />
              </div>
            </div>
          </div>
          <div className="px-2 py-2 inside-form-height overflow-hidden overflow-y-auto small-scroll-bar mb-2 pb-2">
            <p className="mb-1 head-form-support">Let us know your queries</p>
            <div className="divider-head mb-2"></div>
            {message?.code === 200 && (
              <div>
                <Confetti
                  width={window.innerWidth}
                  height={window.innerHeight}
                  // tweenDuration={100}
                  recycle={false}
                  // onConfettiComplete={() => setRun(false)}
                  numberOfPieces={500}
                  friction={0.98}
                  wind={0.1}
                  gravity={0.4}
                />
                <div className="position-relative ">
                  <div className="bg-white-form-support shadow-sm" style={{ height: 'min-content' }}>
                    <Image loading="lazy" alt="support-success-icon" src={Success} width={70} />
                    <h6 className={`message-text`}>
                      <span className="fw-bold">{message?.data}</span>
                      {message?.message}
                    </h6>
                    <button className="btn btn-sm btn-success-cus mb-2" onClick={handleOutsideClick}>
                      <span>Close</span> <FontAwesomeIcon icon={faClose} className="close-icon" />
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className={`${isEmpty(message) ? '' : 'blur-bg-form1'}`}>
              <form className="d-flex flex-column align-items-center gap-2" autoComplete="off">
                <div className="row">
                  <div className="col-6 pe-1">
                    <div
                      className={`input-support animate pop align-items-center d-flex rounded w-100 ${
                        errors?.firstName && 'border border-danger'
                      }`}
                    >
                      <input
                        className="col-10 border-0 outline-none"
                        autoComplete="off"
                        autoFocus
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        placeholder="First name"
                      />
                      {errors?.firstName && (
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-${'firstName'}`}>{errors?.firstName}</Tooltip>}>
                          <FontAwesomeIcon icon={faCircleExclamation} size="lg" className="text-danger mx-2" />
                        </OverlayTrigger>
                      )}
                    </div>
                  </div>
                  <div className="col-6 ps-1">
                    <div className={`input-support animate pop align-items-center d-flex rounded w-100`}>
                      <input
                        className="col-10 border-0 outline-none"
                        autoComplete="off"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        placeholder="Last name"
                      />
                      {/* {errors?.lastName && <FontAwesomeIcon icon={faCircleExclamation} size='lg' className="text-danger mx-2" />} */}
                    </div>
                  </div>
                </div>
                <div
                  className={`input-support animate pop align-items-center d-flex rounded w-100 ${errors?.email && 'border border-danger'}`}
                >
                  <input
                    className="col-11 border-0 outline-none"
                    autoComplete="off"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                  />
                  {errors?.email && (
                    <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-${'email'}`}>{errors?.email}</Tooltip>}>
                      <FontAwesomeIcon icon={faCircleExclamation} size="lg" className="text-danger mx-2" />
                    </OverlayTrigger>
                  )}
                </div>
                <div
                  className={`input-support animate pop align-items-center d-flex rounded w-100 ${errors?.issue && 'border border-danger'}`}
                >
                  <input
                    className="col-11 border-0 outline-none"
                    autoComplete="off"
                    name="issue"
                    value={formData.issue}
                    onChange={handleInputChange}
                    placeholder="Please state your query ?"
                  />
                  {errors?.issue && (
                    <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-${'issue'}`}>{errors?.issue}</Tooltip>}>
                      <FontAwesomeIcon icon={faCircleExclamation} size="lg" className="text-danger mx-2" />
                    </OverlayTrigger>
                  )}
                </div>
                <div
                  className={`input-support-textarea animate pop align-items-center d-flex rounded w-100 ${
                    errors?.additionalDetails && 'border border-danger'
                  }`}
                  style={{ height: 'max-content' }}
                >
                  <textarea
                    className="col-11 border-0 outline-none resize-none"
                    autoComplete="off"
                    name="additionalDetails"
                    value={formData.additionalDetails}
                    onChange={handleInputChange}
                    cols={50}
                    rows={3}
                    placeholder="Additional Details"
                  />
                  {errors?.additionalDetails && (
                    <OverlayTrigger
                      placement={'bottom'}
                      overlay={<Tooltip id={`tooltip-${'additionalDetails'}`}>{errors?.additionalDetails}</Tooltip>}
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} size="lg" className="text-danger mx-2" />
                    </OverlayTrigger>
                  )}
                </div>
                <div
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  className={`${dragOver ? 'w-100 py-2' : 'w-100 py-2'} animate pop delay-2`}
                >
                  <label htmlFor="file-input" className="custom-file-upload py-1">
                    <span className="d-flex flex-column">
                      <span>Attachements</span>
                      <span style={{ fontSize: '10px' }}>
                        <FontAwesomeIcon style={{ marginTop: '6px' }} icon={faUpload} />{' '}
                        {' Drag and Drop or Browse File (Support : PNG, JPG)'}
                      </span>
                    </span>
                  </label>
                  <input id="file-input" type="file" accept=".png, .jpg, .jpeg" onChange={handleFileChange} style={{ display: 'none' }} />
                  <div>
                    {/* <span>{fileName !== "No file chosen" && fileName}
                                   
                                   </span> */}
                    {fileName !== 'No file chosen' && fileName !== null ? (
                      <span onClick={handleReset} className="d-flex gap-2 align-items-center mt-1 text-black ">
                        <span className="text-truncate text-capitalize text-sm" title={fileName}>
                          {fileName}
                        </span>{' '}
                        <span>
                          <FontAwesomeIcon style={{ marginTop: '6px' }} icon={faClose} color="red" />
                        </span>
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <button className="btn-support animate pop delay-2 mb-1" onClick={handleSubmit}>
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
      {showSupportForm !== true && (
        <div className="need-help shadow">
          <p className="">Need Help?</p>
        </div>
      )}

      <div className="icon-support-box shadow" onClick={handleClickOpen}>
        {/* <Image loading="lazy" alt="support-icon" src={SupportIcon} className="img-fluid icon-support" />/ */}
        <FontAwesomeIcon icon={faEnvelope} size='2x' color='#fff' />
      </div>
    </div>
  );
};

const mapStatesToProps = ({
  common: { trendingBondsData = [], isTrendingBondsLoader = true, countryData = [], isCountryLoader = false },
}) => {
  return { trendingBondsData, isTrendingBondsLoader, countryData, isCountryLoader };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      ...commonAction,
      supportForm: commonAction.supportForm,
    },
    dispatch
  );
};

export default memo(connect(mapStatesToProps, mapDispatchToProps)(Support));
